export default "__VITE_ASSET__CmIYN_d0__"